import React from 'react';
import AdminEarnings from '../components/Admin/AdminEarnings';

const AdminEarningsPage = () => {
  return <AdminEarnings />;
};

export default AdminEarningsPage;